import type { GetMyFilesMentionableUsersResponse } from "@nlc/shared-types";
import type { DefaultError } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";
import authenticatedApi from "@/lib/api/client";

export function useMentionableUsers(requestId: number | undefined) {
  const { isTemplate } = useIsTemplate();

  return useQuery<
    GetMyFilesMentionableUsersResponse,
    DefaultError,
    { id: string; label: string }[]
  >({
    enabled: !!requestId && !isTemplate,
    queryFn: async () => {
      if (!requestId) return { mentionableUsers: [] };

      return await authenticatedApi
        .url(`/requests/${requestId}/my-files/mentionable-users`)
        .get()
        .json();
    },
    queryKey: ["mentionableUsers", requestId],
    select: (data) =>
      data.mentionableUsers.map((user) => ({
        id: String(user.id),
        label: user.name,
      })),
  });
}
